import axios from './common/axios';

const API_URL_PAYMENTS = '/payments';
const API_URL_PAYMENTS_CURRENT = '/payments/current';
const API_URL_PAYMENTS_UPDATE_CARD = '/payments/update_card';
const API_URL_PAYMENTS_UPDATE_BILLING_ADDRESS =
  '/payments/update_billing_address';
const API_URL_PAYMENTS_CREATE_SETUP_INTENT = '/payments/create_setup_intent';

export default {
  getAll(callback) {
    axios
      .get(API_URL_PAYMENTS)
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  getCurrent(params, callback) {
    axios
      .get(API_URL_PAYMENTS_CURRENT, {
        params
      })
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  post(params, callback) {
    axios
      .post(API_URL_PAYMENTS, params)
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  delete(params, callback) {
    // axios.delete を送信するときは { data: { foo: "bar" } } として送信する
    // https://github.com/axios/axios/issues/897#issuecomment-343715381
    axios
      .delete(API_URL_PAYMENTS, {
        data: params
      })
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  updateCard(params, callback) {
    axios
      .post(API_URL_PAYMENTS_UPDATE_CARD, params)
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  postCurrent(params, callback) {
    axios
      .post(API_URL_PAYMENTS_CURRENT, params)
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  updateBillingAddress(params, callback) {
    axios
      .post(API_URL_PAYMENTS_UPDATE_BILLING_ADDRESS, params)
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  createSetupIntent(params, callback) {
    axios
      .post(API_URL_PAYMENTS_CREATE_SETUP_INTENT, params)
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => {
        if (err.response?.data?.errors) {
          return callback(err.response?.data?.errors);
        }
        callback(err);
      });
  }
};
